import React, { Component } from "react";
import reactCSS from "reactcss";
import PropTypes from "prop-types";
import { colors } from "assets";
import Icon from "material-ui-next/Icon";
import InfoTooltip from '../info-tooltip';

import "../index.css";

class SelectField extends Component {
  static propTypes = {
    errorText: PropTypes.string,
    sortBy: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.any,
        label: PropTypes.string
      })
    )
  };
  static defaultProps = {
    sortBy: "label",
    errorText: ""
  };
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value || this.props.defaultValue || "",
      isFocused: false,
      error: false
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.errorText === "") {
      this.setError(false);
    } else {
      this.setError(true);
    }
  }
  getLabel() {
    return (
      this.props.label ||
      this.props.floatingLabelText ||
      this.props.hintText ||
      false
    );
  }

  getElement(styles) {
    const {
      value,
      error,
      errorText,
      sortBy,
      options,
      precision,
      separator,
      delimiter,
      unit,
      onChange,
      onBlur,
      onFocus,
      fullWidth,
      hintText,
      floatingLabelFixed,
      floatingLabelText,
      underlineShow,
      underlineStyle,
      labelStyle,
      multiLine,
      type,
      className,
      children,
      ...otherProps
    } = this.props;

    const optionsNotSorted = options.map((option, i) => (
      <option
        key={`${i}-${option.value}`}
        value={option.value}
        disabled={option.disabled}
      >
        {option.label}
      </option>
    ));

    return (
      <select
        onChange={this.handleOnChange}
        onFocus={this.handleOnFocus}
        onBlur={this.handleOnBlur}
        style={styles.input}
        type={type}
        className={className}
        value={!!this.props.value ? this.props.value : this.state.value || ""}
        {...otherProps}
      >
        {optionsNotSorted}
      </select>
    );
  }

  setValue(value) {
    this.setState({
      value
    });
  }

  setError(value) {
    this.setState({
      error: value
    });
  }

  setIsFocused(value) {
    this.setState({
      isFocused: value
    });
  }

  handleOnChange = event => {
    if (this.props.disabled) {
      return;
    }

    if (this.props.onChange) {
      this.props.onChange(event, event.target.value);
    } else {
      this.setValue(event.target.value);
    }
  };

  handleOnFocus = event => {
    if (this.props.disabled) {
      return;
    }

    this.setIsFocused(true);

    if (this.props.onFocus) {
      this.props.onFocus(event);
    }
  };

  handleOnBlur = event => {
    if (this.props.disabled) {
      return;
    }

    this.setIsFocused(false);

    if (this.props.onBlur) {
      this.props.onBlur(event);
    }
  };

  render() {
    const styles = reactCSS(
      {
        isFocused: {
          input: {
            color: colors.primary.normal,
            borderColor: colors.primary.normal
          },
          label: {
            color: colors.primary.normal
          }
        },
        disabled: {
          field: {
            opacity: 0.6
          },
          input: {
            cursor: "not-allowed"
          }
        },
        error: {
          element: {
            border: "none"
          },
          input: {
            border: "1px solid #FF0014",
            borderRadius: 5,
            color: "#FF0014",
            oxSizing: "border-box",
            padding: 5,
            position: "relative",
            width: this.props.fullWidth ? "100%" : 256
          },
          label: {
            color: "#FF0014"
          }
        },
        default: {
          field: {
            display: "inline-block",
            width: "100%",
            boxSizing: "border-box",
            margin: "12px 0 0"
          },
          input: {
            padding: 5,
            outline: "none",
            background: "#FFF",
            borderRadius: 5,
            borderColor: "#CCC",
            border: "1px solid #CCC",
            fontFamily: "Source Sans Pro",
            fontSize: 15,
            width: this.props.fullWidth ? "100%" : 256,
            boxSizing: "border-box",
            color: "#222"
          },
          label: {
            display: 'flex',
            alignItems: 'center',
            width: "100%",
            fontFamily: "Source Sans Pro",
            fontSize: "0.8em",
            fontWeight: "bold",
            marginBottom: 4,
            cursor: "pointer",
            color: "#222"
          },
          errorText: {
            color: "#FF0014",
            marginTop: 0,
            paddingTop: "0.4em",
            fontSize: "0.6em",
            fontFamily: "Source Sans Pro"
          }
        }
      },
      this.props,
      this.state
    );
    return (
      <div
        className="select-field"
        style={{ ...styles.field, ...this.props.selectfieldstyle }}
      >
        <label>
          {this.getLabel() && (
            <div className="select-field--label" style={styles.label}>
              {this.getLabel()}

              {this.props.tooltip && (
                <InfoTooltip hint={this.props.tooltip} type="help" />
              )}
            </div>
          )}
          <div className="select-field--element" style={styles.element}>
            {this.getElement(styles)}
            {this.props.allowClear && this.getValue().length > 0 && (
              <div
                className="select-field--clear-button"
                onClick={this.handleClearButton}
                style={styles.clearButton}
              >
                <Icon style={{ paddingTop: 4, fontSize: "1.9em" }}>close</Icon>
              </div>
            )}
            {this.props.errorText.length > 0 && (
              <p className="error-text-message" style={styles.errorText}>
                {this.props.errorText}
              </p>
            )}
          </div>
        </label>
      </div>
    );
  }
}

export default SelectField;



// WEBPACK FOOTER //
// ./src/components/support/select-field/index.jsx